import { ReminderConfigurationUnitTypeEnum } from '@/types/schema';

export const ReminderUnits = [
  ReminderConfigurationUnitTypeEnum.Minutes,
  ReminderConfigurationUnitTypeEnum.Days,
  ReminderConfigurationUnitTypeEnum.Months,
];

export const ReminderUnitsConfig = {
  [ReminderConfigurationUnitTypeEnum.Minutes]: 'Reminder.Units.Minutes',
  [ReminderConfigurationUnitTypeEnum.Days]: 'Reminder.Units.Days',
  [ReminderConfigurationUnitTypeEnum.Months]: 'Reminder.Units.Months',
};
